import { storageService } from 'js/services/storage.service';
import {
    notifyActionOpenNotification as notifyActionOpenNotificationCore
} from 'js/components/system/App/hooks/usePushNotifier/pushes/notifyActionOpenNotification/notifyActionOpenNotification';

export const notifyActionOpenNotification = (...props) => {
    if (storageService.session.getItem('skipNotification')) {
        return null;
    }

    return notifyActionOpenNotificationCore(...props);
};
